import { useState } from "react"
import './App.css';
import Sidebar from './Sidebar';
import MainContent from "./MainContent"
import Home from "./Home"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import ProtectedRoute from "./ProtectedRoute"; 
import { HelmetProvider } from 'react-helmet-async';


function App() {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [displayName, setDisplayName] = useState("");

  return (
    <HelmetProvider>
    <Router>
      <Routes>

        <Route path="/" element={<Home />} />

        <Route element={<ProtectedRoute />}>
          <Route
            path="/home"
            element={
              <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
                <div className="sidebar" style={{ width: "250px", flexShrink: 0 }}>
                  <Sidebar selectedTopic={selectedTopic} setSelectedTopic={setSelectedTopic} selectedDisplayName={displayName} setSelectedDisplayName={setDisplayName} />
                </div>
                <div className="mainContent" style={{ flexGrow: 1, overflowY: "auto", padding: "20px", background: "#f8f9fa" }}>
                  <MainContent selectedTopic={selectedTopic} displayName={displayName}/>
                </div>
              </div>
            }
          />
        </Route>
      </Routes>
    </Router>
    </HelmetProvider>
  );
  
}

export default App;
